<template>
  <!--  <div class="team-rank team-rank-overflow">-->
  <!--    <div class="shadow">-->
  <!--      <div class="left-top-triangle"></div>-->
  <!--      <div class="header-title" style="color:white;">战队积分榜</div>-->
  <!--      <div class="header-title" style="color:white;font-size: 20px;">A组</div>-->
  <!--      <div class="team-rank-header">-->
  <!--        <div class="header-column">-->
  <!--          <div class="rank">名次</div>-->
  <!--          <div class="team-info">战队</div>-->
  <!--          <div class="win-lose-count">胜/负</div>-->
  <!--          <div class="score">积分</div>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--      <div class="divider"></div>-->
  <!--      <div class="team-rank-list">-->
  <!--        <div class="team" v-for="(team, i) in teamRankList[0]" :key="i" :class="{'striped':i % 2 !== 0}">-->
  <!--          <div class="rank">-->
  <!--            <span v-if="i < 3" :class="[`rank-bg-${team.rank}st`]"></span>-->
  <!--            <span v-else>{{ team.rank }}</span>-->
  <!--          </div>-->
  <!--          <div class="team-info">-->
  <!--            &lt;!&ndash;          <img class="team-icon" :src="team.team_img" :alt="team.team"/>&ndash;&gt;-->
  <!--            <img class="team-icon" :src="'/static/img/team_logo/'+team.team+'.png'" :alt="team.team">-->
  <!--            <div class="team-name">{{ team.team }}</div>-->
  <!--          </div>-->
  <!--          <div class="win-lose-count">{{ team.win_loss }}</div>-->
  <!--          <div class="score">{{ team.score }}</div>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->


  <!--    <div class="header-title" style="color:white;font-size: 20px;">B组</div>-->
  <!--    <div class="team-rank-header">-->
  <!--      <div class="header-column">-->
  <!--        <div class="rank">名次</div>-->
  <!--        <div class="team-info">战队</div>-->
  <!--        <div class="win-lose-count">胜/负</div>-->
  <!--        <div class="score">积分</div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--    <div class="divider"></div>-->
  <!--    <div class="team-rank-list">-->
  <!--      <div class="team" v-for="(team, i) in teamRankList[1]" :key="i" :class="{'striped':i % 2 !== 0}">-->
  <!--        <div class="rank">-->
  <!--          <span v-if="i < 3" :class="[`rank-bg-${team.rank}st`]"></span>-->
  <!--          <span v-else>{{ team.rank }}</span>-->
  <!--        </div>-->
  <!--        <div class="team-info">-->
  <!--          &lt;!&ndash;          <img class="team-icon" :src="team.team_img" :alt="team.team"/>&ndash;&gt;-->
  <!--          <img class="team-icon" :src="'/static/img/team_logo/'+team.team+'.png'" :alt="team.team">-->
  <!--          <div class="team-name">{{ team.team }}</div>-->
  <!--        </div>-->
  <!--        <div class="win-lose-count">{{ team.win_loss }}</div>-->
  <!--        <div class="score">{{ team.score }}</div>-->
  <!--      </div>-->
  <!--    </div>-->

  <!--    <div class="header-title" style="color:white;font-size: 20px;">C组</div>-->
  <!--    <div class="team-rank-header">-->
  <!--      <div class="header-column">-->
  <!--        <div class="rank">名次</div>-->
  <!--        <div class="team-info">战队</div>-->
  <!--        <div class="win-lose-count">胜/负</div>-->
  <!--        <div class="score">积分</div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--    <div class="divider"></div>-->
  <!--    <div class="team-rank-list">-->
  <!--      <div class="team" v-for="(team, i) in teamRankList[2]" :key="i" :class="{'striped':i % 2 !== 0}">-->
  <!--        <div class="rank">-->
  <!--          <span v-if="i < 3" :class="[`rank-bg-${team.rank}st`]"></span>-->
  <!--          <span v-else>{{ team.rank }}</span>-->
  <!--        </div>-->
  <!--        <div class="team-info">-->
  <!--          &lt;!&ndash;          <img class="team-icon" :src="team.team_img" :alt="team.team"/>&ndash;&gt;-->
  <!--          <img class="team-icon" :src="'/static/img/team_logo/'+team.team+'.png'" :alt="team.team">-->
  <!--          <div class="team-name">{{ team.team }}</div>-->
  <!--        </div>-->
  <!--        <div class="win-lose-count">{{ team.win_loss }}</div>-->
  <!--        <div class="score">{{ team.score }}</div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->


<!--  <div class="team-rank">-->
<!--    <div class="left-top-triangle"></div>-->
<!--    <div class="header-title" style="color:white;margin-top: 8px;">战队积分榜</div>-->
<!--    <div class="schedule-swiper">-->
<!--      &lt;!&ndash;      <div @click="slidePrev" class="prev-button control-button" :class="{'disabled-button': activeIndex === 0}"></div>&ndash;&gt;-->
<!--      <div class="swiper" style="width: 100%">-->
<!--        <swiper :options="swiperOption" ref="rankSwiper">-->
<!--          <swiper-slide v-for="(slide, i) in teamList" :key="i" :class="{'selected-slide': i === 0}">{{ slide }}-->
<!--          </swiper-slide>-->
<!--        </swiper>-->
<!--      </div>-->
<!--      &lt;!&ndash;      <div @click="slideNext" class="next-button control-button" :class="{'disabled-button': activeIndex === roundList.length - 5}"></div>&ndash;&gt;-->
<!--    </div>-->
<!--    <div class="team-rank-header">-->
<!--      <div class="header-column">-->
<!--        <div class="rank">名次</div>-->
<!--        <div class="team-info">战队</div>-->
<!--        <div class="win-lose-count">胜/负</div>-->
<!--        <div class="score">积分</div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="divider"></div>-->
<!--    <div class="team-rank-list">-->
<!--      <div class="team" v-for="(team, i) in teamRankList[roundIndex]" :key="i" :class="{'striped':i % 2 !== 0}">-->
<!--        <div class="rank">-->
<!--          <span v-if="i < 3" :class="[`rank-bg-${team.rank}st`]"></span>-->
<!--          <span v-else>{{ team.rank }}</span>-->
<!--        </div>-->
<!--        <div class="team-info">-->
<!--          &lt;!&ndash;          <img class="team-icon" :src="team.team_img" :alt="team.team"/>&ndash;&gt;-->
<!--          <img class="team-icon" :src="'/static/img/team_logo/'+team.team+'.png'" :alt="team.team">-->
<!--          <div class="team-name">{{ team.team }}</div>-->
<!--        </div>-->
<!--        <div class="win-lose-count">{{ team.win_loss }}</div>-->
<!--        <div class="score">{{ team.score }}</div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->


    <div class="team-rank">
      <div class="left-top-triangle"></div>
      <div class="header-title" style="color:white;margin-top: 8px;">战队积分榜</div>
      <div class="schedule-swiper">
        <!--      <div @click="slidePrev" class="prev-button control-button" :class="{'disabled-button': activeIndex === 0}"></div>-->
<!--        <div class="swiper">-->
<!--          <swiper :options="swiperOption" ref="scheduleSwiper">-->
<!--            <swiper-slide v-for="(slide, i) in teamList" :key="i" :class="{'selected-slide': i === 0}">{{ slide }}-->
<!--            </swiper-slide>-->
<!--          </swiper>-->
<!--        </div>-->
        <!--      <div @click="slideNext" class="next-button control-button" :class="{'disabled-button': activeIndex === roundList.length - 5}"></div>-->
      </div>
      <div class="team-rank-header">
        <div class="header-column">
          <div class="rank">名次</div>
          <div class="team-info">战队</div>
          <div class="win-lose-count">胜/负</div>
          <div class="score">积分</div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="team-rank-list">
        <div class="team" v-for="(team, i) in teamRankList" :key="i" :class="{'striped':i % 2 !== 0}">
          <div class="rank" style="font-size: 22px;">
            <span v-if="i < 3" :class="[`rank-bg-${team.rank}st`]"></span>
            <span v-else>{{ team.rank }}</span>
          </div>
          <div class="team-info">
            <!--          <img class="team-icon" :src="team.team_img" :alt="team.team"/>-->
            <img class="team-icon" :src="'/static/img/team_logo/'+team.team+'.png'" :alt="team.team">
            <div class="team-name" :style="{'fontSize':  team.team === 'XROCK.斗鱼' ? '24px' : '24px'}">{{ team.team }}</div>
          </div>
          <div class="win-lose-count" style="font-size: 22px;">{{ team.win_loss }}</div>
          <div class="score" style="font-size: 22px;">{{ team.score }}</div>
        </div>
      </div>
    </div>
</template>

<script>
import {images} from '@/utils/imagesUtil'
import axios from "axios";
import {Loading} from "element-ui";

let that = null;
export default {
  name: "TeamRank",
  props: {
    teamRankList: Array,
  },
  data() {
    return {
      images,
      // teamList: ['A组','B组','C组'],
      // teamList: ['A组', 'B组','C组','D组'],
      scheduleList: [],
      SelectScheduleList: [],
      swiperOption: {
        // autoplay: 3500,
        slidesPerView: 'auto',
        // spaceBetween: 10,
        setWrapperSize: true,
        paginationClickable: true,
        mousewheelControl: true,
        observeParents: true,
        grabCursor: true,
        onTap(swiper) {
          that.toggleClass(swiper)
        },
        onSlideChangeEnd(swiper) {
          that.activeIndex = swiper.activeIndex
        }
      },
      roundIndex: 0,
    }
  },
  created() {
    that = this;
  },
  computed: {
    swiper() {
      return this.$refs.rankSwiper.swiper
    },
  },
  methods: {
    toggleClass: function (swiper) {
      // 所有 slide dom
      let slides = swiper.slides
      // 当前点击的 index
      let clickedIndex = swiper.clickedIndex
      if (clickedIndex > -1) {
        this.roundIndex = clickedIndex
        // swiper-slide 标签使用 :class 无法动态绑定 class, 这里手动移除添加 class
        Object.entries(slides).forEach((v, i) => {
          let slide = v[1]
          if (slide.classList) {
            if (slide.classList.contains('selected-slide') && i !== clickedIndex) {
              slide.classList.remove('selected-slide')
            } else if (i === clickedIndex) {
              slide.classList.add('selected-slide')
            }
          }
        })
      }
    },
    slidePrev: function () {
      if (this.activeIndex !== 0) {
        this.swiper.slidePrev()
      }
    },
  }
}
</script>

<style scoped>
.team-rank-overflow {
  overflow-y: auto;
  height: 678px;
}

.team-rank-overflow::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Opera */
}

.team-rank {
  position: relative;
  width: 400px;
  height: 680px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid #fabf8b;
  background: url("~@/assets/images/2024CFPLPC.png") no-repeat;
  background-size: cover;
  /*background-position: 0 200px;*/
}

.shadow {
  /*position: absolute;*/
  /*top: 0;*/
  /*left: 0;*/
  /*width: 422px;*/
  /*height: 678px;*/
  /*background: rgba(0, 0, 0, .5)*/
}

.left-top-triangle {
  background-image: url("../../../../../assets/images/triangle.svg");
  position: absolute;
  left: 3px;
  top: 3px;
  width: 12px;
  height: 12px;
  z-index: 8;
}

.team-rank-header {
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  /*width: 420px;*/
  height: 69px;
  background: rgba(0, 0, 0, 0.3);
  color: #FFFFFF;
}

.header-title {
  font-size: 18px;
  font-weight: bold;
}

.header-column {
  display: flex;
  font-size: 16px;
  text-align: center;
}

.divider {
  width: 400px;
  height: 1px;
  background: #fabf8b;
  opacity: 0.3;
}

.team {
  height: 50px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  text-align: center;
  border-bottom: 1px solid #956840;
}

.striped {
  background-color: rgba(0, 0, 0, 0.3);
}

.rank {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 75px;
  font-weight: bold;
  font-size: 24px;
}

.rank > span {
  display: inline-block;
  width: 29px;
  height: 31px;
  line-height: 31px;
  background-size: cover;
}

.rank-bg-1st {
  background-image: url("../../../../../assets/images/1st.png");
}

.rank-bg-2st {
  background-image: url("../../../../../assets/images/2nd.png");
}

.rank-bg-3st {
  background-image: url("../../../../../assets/images/3rd.png");
}

.team-info {
  display: flex;
  align-items: center;
  width: 200px;
  height: 100%;
  font-weight: bold;
  font-size: 24px;
}

.team-icon {
  width: 35px;
  height: 35px;
}

.team-name {
  width: 165px;
  margin-left: 10px;
  text-align: left;
  font-weight: bold;
}

.win-lose-count {
  width: 75px;
  font-weight: bold;
  font-size: 24px;
}

.score {
  width: 75px;
  font-weight: bold;
  font-size: 24px;
}

.swiper {
  /*width: 600px;*/
  width: 560px;
  overflow: hidden;
  /*display: flex;*/
  /*justify-content: space-evenly;*/
  /*!*justify-content:center;*!*/
  /*align-items: center;*/
  margin-left: 5px;
  margin-top: 15px;
  margin-bottom: 3px;
}

.swiper-slide {
  width: 100px !important;
  height: 34px;
  line-height: 34px;
  background: rgba(0, 0, 0, 0.05);
  border: 1px solid #fabf8b;
  margin-right: 10px;
  color: #FFFFFF;
}

.selected-slide {
  /*background: #fabf8b;*/
  background: url("../../../../../assets/images/selected_slide.png");
}
</style>



// WEBPACK FOOTER //
// src/components/iframe/matchSchedule/common/RegularSeason/TeamRank.vue